export const CONSENT_COOKIE = 'consent_cookie';
export const LANDING_PROMO_MODAL_COOKIE = 'landing_promo_modal';
export const COOKIE_SWITCH_USER = '_switch_user';
export const COOKIE_ASSIGN_FEATURE = 'assign_feature';
